import { motion } from 'framer-motion';
import { MessageSquare } from 'lucide-react';

export const EmptyChat = () => {
  return (
    <div className="h-full flex items-center justify-center bg-slate-50 dark:bg-slate-950">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="text-center space-y-4"
      >
        <motion.div
          animate={{ 
            y: [0, -10, 0],
          }}
          transition={{ 
            duration: 2, 
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-emerald-100 dark:bg-emerald-900/30 text-emerald-500"
        >
          <MessageSquare className="w-10 h-10" />
        </motion.div>
        
        <h2 className="text-xl font-semibold text-slate-900 dark:text-white">
          Wählen Sie einen Chat
        </h2>
        <p className="text-slate-500 dark:text-slate-400 max-w-sm">
          Starten Sie eine Unterhaltung, indem Sie einen bestehenden Chat auswählen 
          oder einen neuen Chat erstellen.
        </p>
      </motion.div>
    </div>
  );
};

export default EmptyChat;
